import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController,LoadingController,Events,AlertController } from 'ionic-angular';

/**
 * Generated class for the SignupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-signup',
  templateUrl: 'signup.html',
})
export class SignupPage {
  selectedValue: string = '';
  
  showVideo: boolean = false;

  name:string;
  businessName:string;
  firstName:string;
  lastName:string;
  email:string;
  phone:string;
 loader:any;
 password:string;
  confirmPassword:string;
     passwordType: string = 'password';
  confirmPasswordType: string = 'password';
    passwordIcon: string = 'eye-off';
  isTextSelected: boolean = false;
  inputValue:any = "";
  
  constructor(public navCtrl: NavController, public navParams: NavParams,  public events:Events,public loadingCtrl: LoadingController, public alertCtrl:AlertController) {

    
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SignupPage');
  }

  async ionViewWillEnter(){

   this.intializeSubscriptions();

  }

  ionViewWillLeave(){
      this.removeSubscriptions();
  }

  playVideo() {
    this.showVideo = true;
  }
  
  closeVideo() {
    this.showVideo = false;
  }

    // hideShowPassword() {
    //  this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
    //  this.passwordIcon = this.passwordIcon === 'eye-off' ? 'eye' : 'eye-off';
    // }

    hideShowPassword(type: string) {
      console.log('type', type)
      if (type === 'password') {
        this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
      } else if (type === 'confirmPassword') {
        this.confirmPasswordType = this.confirmPasswordType === 'text' ? 'password' : 'text';
      }
    }

  routeToActivationPage() {

    // Validate non-empty fields
    if (!this.email || !this.businessName || !this.firstName || !this.lastName || !this.phone || !this.selectedValue || !this.password) {
        let alert = this.alertCtrl.create({
            title: 'Alert',
            subTitle: 'Please fill out all required fields.',
            buttons: [{
                text: 'Ok',
                handler: data => {

                }
            }]
        });
        alert.present();
        return; // Exit the function if validation fails
    }

    this.loader =  this.loadingCtrl.create({
            content: "Please wait! creating your account.."
             });

            this.loader.present();

    let details = {
      email:this.email,
      businessName : this.businessName,
      firstName : this.firstName,
      lastName: this.lastName,
      name : this.firstName + ' '+this.lastName,
      phone:this.phone,
      muncipality: this.selectedValue,
      key:this.password

    }
    this.events.publish('auth:signupUser',details);

 

   
  }

  intializeSubscriptions(){
   

     this.events.subscribe('auth:signupUserCompleted', (res) => {
          //alert("Please check your email, we have send you activation link");

            if(this.loader){
           this.loader.dismiss();

           if(res.alreadyExists){
              let alert = this.alertCtrl.create({
              title: 'Account Reactivated',
              subTitle: "Your email is already registered, we have sent you an activation email to activate your account.",
              buttons: [{
                  text: 'Ok',
                  handler: data => {
                     this.navCtrl.push('LoginPage');
                  }
                }]
            });
            alert.present();
           }
           else{
           let alert = this.alertCtrl.create({
              title: 'Account Activated',
              subTitle: `We have sent an activation email on ${this.email} to verify your account.<br><br>
              If you do not receive it, please look in your Junk or SPAM folders.<br><br>
              Please click OK to continue`,
              buttons: [{
                  text: 'Ok',
                  handler: data => {
                     this.navCtrl.push('LoginPage');
                  }
                }],
              cssClass: 'acc-activate-alert'
            });
            alert.present();
           }
      }
         
     });

       this.events.subscribe('auth:signupUserFailed', (res) => {

           if(this.loader){
           this.loader.dismiss();
          }


            let alert = this.alertCtrl.create({
              title: 'Account Activation Failed',
              subTitle: "We can't create your account right now, please try after some time",
              buttons: [{
                  text: 'Ok',
                  handler: data => {
                  }
                }]
            });
            alert.present();
   
           //alert("We can't create your account right now, please check if your email is already registered");
     });

  }

  checkSelectedValue(value: string): void {
    if (value === 'text') {
      this.isTextSelected = true;
      this.selectedValue = '';
    }
  }

  onInputChange(value: string): void {
    if (value && value.trim() !== '') {
      this.selectedValue = value;
    }
  }

  showCouncilOptions() {
    this.isTextSelected = false;
  }

  isPasswordMatching(): boolean {
    return this.password === this.confirmPassword;
  }
  

  removeSubscriptions(){
     this.events.unsubscribe('auth:signupUserCompleted');
     this.events.unsubscribe('auth:signupUserFailed');
  }


}



// WEBPACK FOOTER //
// ./src/pages/signup/signup.ts